import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

// Version 1 of this id is klinecharts' Chinese "smoothed" MA; from version 2 SMA means TA-Lib's simple MA.
const def: IndicatorDef = {
  id: 'SMA',
  version: 2,
  label: 'Simple Moving Average',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 30,
  inputs: [period('timeperiod', 30)],
  outputs: [line('sma', 'SMA', COLOR.blue)],
  talib: { functions: ['SMA'], expr: 'SMA(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
